export default {
  state: {
    host: '', // заполняется в main.js
    ngwHost: '', // заполняется в main.js
    analitHost: '', // заполняется в main.js
    mapUrl: '/api/resource/29',
    minioHost: '', // заполняется в main.js
    iamHost: '' // заполняется в main.js
  },
  mutations: {
    setValue (state, keyValue) {
      state[keyValue.key] = keyValue.value
    }
  },
  actions: {
    SET_VALUE ({commit}, keyValue) {
      commit('setValue', keyValue)
    }
  },
  getters: {
    HOST: state => {
      return state.host
    }
  }
}



// WEBPACK FOOTER //
// ./src/storages/modules/httpStore.js